<script setup lang="ts">
import { useProductPrice } from "@shopware-pwa/composables-next";
import { Tint } from "~/components/clarity-ui/Tint";
import { FormattedPercent } from "~/components/ui/FormattedPercent";
import { useExchangeBox } from "~/composables/shop/useExchangeBoxProduct";
import { useProductEShopSetConfigurator } from "~/composables/shop/useProductEShopSetConfigurator";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import ProductCardBulkPrice from "~/templates/components/shop/product/ProductCardBulkPrice.vue";

const { product } = useProduct();
const { eShopSet, hasEShopSet, hasBestPrice } = await useProductEShopSetConfigurator();
const { hasBulkPrice } = useProductBulkPrices(product);

const { price, unitPrice, isListPrice } = useProductPrice(product);
const { tauschbox, amountCylinders } = await useExchangeBox();
</script>

<template>
  <div>
    <template v-if="hasEShopSet">
      <div v-if="hasBestPrice" class="flex items-end gap-2">
        <SharedPrice class="font-medium" discounted :value="eShopSet?.eshopSetPriceTotal" />
        <Tint><SharedPrice strikethrough :value="eShopSet?.bestEshopPriceFromHistory" /></Tint>
      </div>
      <SharedPrice
        v-else
        :value="eShopSet?.eshopSetPriceTotal || price?.totalPrice"
        class="font-medium"
      />
    </template>

    <ProductCardBulkPrice v-else-if="hasBulkPrice" />

    <template v-else>
      <div class="flex flex-wrap items-center gap-3 xl:flex-nowrap">
        <SharedPrice
          v-if="unitPrice"
          class="font-medium"
          :discounted="isListPrice"
          :value="unitPrice"
        />
        <SharedPrice v-if="isListPrice" strikethrough :value="price?.listPrice?.price" />
      </div>
      <div v-if="isListPrice" class="flex gap-1 text-sm">
        <CommonLabel path="BWF/shop/productDetailPage/priceSaving" />
        <SharedPrice v-if="isListPrice" :value="price?.listPrice?.discount" />
        (<FormattedPercent :value="Math.abs(price?.listPrice?.percentage ?? 0)" :precision="0" />)
      </div>
      <Tint v-if="tauschbox" class="text-sm">
        <CommonLabel
          path="BWF/shop/exchangeBox/priceCardExchangeBoxHint"
          :placeholder="{ amountCylinders }"
        />
      </Tint>
    </template>
  </div>
</template>
